"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * Data converter for Sellout Release Total row.
 *
 * @author Radek Beran
 */


var SelloutReleaseTotalDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseTotalDTOConverter, _DataObjectConverter_);

  function SelloutReleaseTotalDTOConverter() {
    _classCallCheck(this, SelloutReleaseTotalDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseTotalDTOConverter).apply(this, arguments));
  }

  return SelloutReleaseTotalDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseTotalDTOConverter = SelloutReleaseTotalDTOConverter;